import { DismissIcon, ErrorIcon } from './ToasterIcons';

interface Props {
  dismissMessageHandler: (e: any) => void;
  showMessage: boolean;
  message: string;
  details?: string;
}

export const Toaster = (props: Props) => {
  return (
    <>
      {props.showMessage &&
        (
          <div id="toast" className="toasts-container toasts-inner">
            <div className="toast-icon-container">
              <ErrorIcon />
            </div>
            <div className="toast-text-container">
              <div className="toast-message" data-testid="toast-message-view">{props.message}</div>
              {props.details && <div className="toast-details" data-testid="toast-details-view">{props.details}</div>}
            </div>
            <div className="toast-button-container">
              <a href="#/" onClick={props.dismissMessageHandler} className="toast-dismiss-button">
                <DismissIcon />
              </a>
            </div>
          </div>
        )
      }
    </>
  );
};
